export const CHANGE_FORM = "sendResetPassword/CHANGE_FORM";
export const INIT = "sendResetPassword/INIT";
export const SET_ERRORS = "sendResetPassword/SET_ERRORS";

export const changeForm = (key, value) => ({
  type: CHANGE_FORM,
  key,
  value
});

export const init = () => ({
  type: INIT
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  customerId: "",
  loginId: "",
  errors: []
};

const sendResetPassword = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_FORM: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case INIT: {
      return initialState;
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    default:
      return state;
  }
};

export default sendResetPassword;



// WEBPACK FOOTER //
// ./src/redux/modules/sendResetPassword.js